import { useEffect, useState } from 'react'
import type { Book, DownloadFormat } from '../../shared/types'
import { COLLECTION_DESCRIPTION, COLLECTION_NAME } from '../../shared/catalogue'
import { Brand } from '../App'
import { BookCard } from '../components/BookCard'
import { DownloadDialog } from '../components/DownloadDialog'
import { getCatalogue } from '../lib/api'

export function CataloguePage() {
  const [books, setBooks] = useState<Book[]>([])
  const [selectedDownload, setSelectedDownload] = useState<{ book: Book | 'all'; format: DownloadFormat } | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    getCatalogue().then(setBooks).catch((reason: unknown) => {
      setError(reason instanceof Error ? reason.message : 'Não foi possível carregar as obras.')
    })
  }, [])

  return (
    <div className="app-shell">
      <header className="site-header">
        <Brand />
        <a href="#obras" className="header-link">Ver obras</a>
      </header>
      <main>
        <section className="hero">
          <div>
            <span className="eyebrow">Conhecimento para transformar</span>
            <h1>{COLLECTION_NAME}</h1>
            <p>{COLLECTION_DESCRIPTION}</p>
            <div className="hero-actions">
              <button
                type="button"
                className="button button-primary"
                onClick={() => setSelectedDownload({ book: 'all', format: 'pdf' })}
              >
                Baixar Coleção Completa (6 Obras)
              </button>
              <a className="button button-secondary" href="#obras">
                Explorar obras individuais <span aria-hidden="true">↓</span>
              </a>
            </div>
          </div>
          <div className="hero-mark" aria-hidden="true">
            <span>06</span>
            <small>obras digitais</small>
          </div>
        </section>
        <section className="collection" id="obras" aria-labelledby="collection-title">
          <div className="section-heading">
            <div>
              <span className="eyebrow">Biblioteca</span>
              <h2 id="collection-title">Escolha a sua próxima leitura</h2>
              <p>Disponível em PDF e EPUB.</p>
            </div>
            <button
              type="button"
              className="button button-secondary"
              onClick={() => setSelectedDownload({ book: 'all', format: 'pdf' })}
            >
              Baixar toda a coleção
            </button>
          </div>
          {error ? (
            <div className="status-message" role="alert">{error}</div>
          ) : books.length === 0 ? (
            <div className="status-message">Carregando obras...</div>
          ) : (
            <div className="book-grid">
              {books.map((book) => (
                <BookCard
                  key={book.id}
                  book={book}
                  onDownload={(selectedBook, format) => setSelectedDownload({ book: selectedBook, format })}
                />
              ))}
            </div>
          )}
        </section>
      </main>
      <footer className="site-footer">
        <div className="footer-collection-heading">
          <span className="footer-collection-title">{COLLECTION_NAME}</span>
          <div className="footer-elegant-bar" aria-hidden="true" />
          <span className="footer-publisher">Publicado por Datasci Editora</span>
        </div>
        <Brand compact />
      </footer>
      <DownloadDialog
        book={selectedDownload?.book ?? null}
        initialFormat={selectedDownload?.format ?? 'pdf'}
        onClose={() => setSelectedDownload(null)}
      />
    </div>
  )
}
